import { render, staticRenderFns } from "./AdRecommendCell.vue?vue&type=template&id=34901044&scoped=true"
import script from "./AdRecommendCell.vue?vue&type=script&lang=js"
export * from "./AdRecommendCell.vue?vue&type=script&lang=js"
import style0 from "./AdRecommendCell.vue?vue&type=style&index=0&id=34901044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34901044",
  null
  
)

export default component.exports